<template>
  <div class="" @click.self="openModal">
    <div>
      <div
        class="open-offers-btn"
        :class="{
          totalStyleMobile:
            type === 'total' && $route.name !== 'SingleGameMarket',
          sportsBookStyle:
            $route.name !== 'Exchange' && $route.name !== 'SingleGameMarket',
          exchangeStyle:
            $route.name === 'Exchange' && $route.name !== 'SingleGameMarket',
          singleGameStyle: $route.name === 'SingleGameMarket',
          spreadStyle:
            type === 'spread' &&
            $route.name !== 'Exchange' &&
            $route.name !== 'SingleGameMarket',
        }"
        @click.stop="openModal"
      >
        <div
          class="inner-div"
          :class="{ 'inner-div-single': $route.name === 'SingleGameMarket' }"
        >
          <font-awesome-icon size="2xs" :icon="faPenToSquare" />
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare';

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['openModal']);

function openModal() {
  emit('openModal');
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/tokens.scss' as main;

.open-offers-btn {
  position: absolute;
  right: 1px;
  padding: 0;
  width: 8px;
  cursor: pointer;
  color: main.$white_02;
  font-size: 9px;
  z-index: 1;
  background-color: main.$blue-201;
  height: 10px;

  &:hover {
    background: main.$grey-2701;
  }

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    margin-top: 1px;
  }
}

.inner-div {
  margin-top: -2px;
}

.inner-div-single {
  margin-left: 4px;
}

.totalStyleMobile {
  right: 1px;
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    right: 9px !important;
  }
}

.sportsBookStyle {
  width: 13px;
  margin-top: 0px;
  right: 8px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  height: 13px;
  font-size: 11px;

  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    margin-top: 1px;
    right: 1px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}

.singleGameStyle {
  width: 13px;
  margin-top: 0px;
  right: 0;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  height: 13px;
  font-size: 11px;
}

.spreadStyle {
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    width: 13px;
    margin-top: 0px;
    right: 5px;
    height: 13px;
    font-size: 11px;
  }
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    width: 13px;
    margin-top: 1px;
    right: 1px;
    height: 13px;
    font-size: 11px;
  }
}

.exchangeStyle {
  @media screen and (max-width: map.get(main.$grid-breakpoints, md)) {
    width: 13px;
    margin-top: 0px;
    height: 13px;
    font-size: 11px;
    margin-top: 1px;
  }
  @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
    width: 13px;
    height: 13px;
    margin-top: 1px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
    font-size: 11px;
  }
}
</style>
